import { useCallback, useContext } from 'react';

import { VolatileSettingsContext } from '../contexts/volatileSettings.context';
import { SearchPopupPhase } from '../enums';
import { UseVolatileSettings } from '../interfaces/hooks';
import { VolatileSettingsContextData } from '../types/internal';

export const useVolatileSettings: () => UseVolatileSettings = (): UseVolatileSettings => {
  const [volatileSettings, updateVolatileSettings]: VolatileSettingsContextData = useContext(VolatileSettingsContext);

  const changeComparisonTablePopupVisible: (isVisible: boolean) => void = useCallback((isVisible: boolean): void => {
    updateVolatileSettings({ ...volatileSettings, isComparisonTablePopupVisible: isVisible });
  }, [updateVolatileSettings, volatileSettings]);

  const changeAppLoadingScreenVisible: (isVisible: boolean) => void = useCallback((isVisible: boolean): void => {
    updateVolatileSettings({ ...volatileSettings, isAppLoadingVisible: isVisible });
  }, [updateVolatileSettings, volatileSettings]);

  const handleSearchPopupOpen: (initialQuery?: string) => void = (initialQuery: string = ''): void => {
    updateVolatileSettings({ ...volatileSettings, searchPopupSettings: { phase: SearchPopupPhase.Open, initialQuery } });
  };

  const handleSearchPopupClose: () => void = (): void => {
    updateVolatileSettings({
      ...volatileSettings,
      searchPopupSettings: { ...volatileSettings.searchPopupSettings, phase: SearchPopupPhase.Closing },
    });

    setTimeout((): void => {
      updateVolatileSettings({
        ...volatileSettings,
        searchPopupSettings: { phase: SearchPopupPhase.Closed, initialQuery: '' },
      });
    }, 300);
  };

  return {
    volatileSettings,
    changeComparisonTablePopupVisible,
    changeAppLoadingScreenVisible,
    handleSearchPopupOpen,
    handleSearchPopupClose,
  };
};
